import type { FilterExportSchema } from '@troph-team/pixai-image-art-filters'
import { usePublicDynamicConfig } from 'src/services/restful/dynamicConfig'

type ImageArtFiltersConfig = {
  filters: (FilterExportSchema & { id: string; name: string })[]
}
export const useImageArtFilters = () => {
  const { data, isLoading } =
    usePublicDynamicConfig<ImageArtFiltersConfig>('imageArtFilters')
  return { filters: data?.filters, isLoading }
}
